<template>
    <div>
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 5px" class="flex y-center flex-wrap">
            <div class="flex flex-wrap">
                <div class="flex mr40 y-center info-item">
                    <div class="color666 flex-item">{{ $t('notice.email_balance_available' /* 可用金额 */) }}</div>
                    <b class="fs22 ml10 warning-color">¥{{ balance.balance }}</b>
                </div>
                <div class="flex mr40 y-center info-item">
                    <div class="color666 flex-item">{{ $t('notice.sms_price' /* 短信价格 */) }}</div>
                    <b class="fs22 ml10 warning-color">¥{{ balance.sms_unit_price }}/{{ $t('notice.items' /* 条 */) }}</b>
                </div>
                <div class="flex y-center info-item">
                    <div class="color666 flex-item">{{ $t('notice.sms_sendable_count' /* 可发短信数 */) }}</div>
                    <b class="fs22 ml10 warning-color">¥{{ balance.sms_items }}/{{ $t('notice.items' /* 条 */) }}</b>
                </div>
            </div>
            <a-button size="large" type="primary" style="width: 150px">{{ $t('notice.btn_recharge_online' /* 在线充值 */) }}</a-button>
        </div>
        <div class="mt15">
            <a target="_blank" href="https://files.sciconf.cn/upload/file/20240725/20240725163756_45136.xlsx​">
                <a-button type="primary">{{ $t('notice.download_template' /* 下载模板 */) }}</a-button>
            </a>
        </div>
        <p class="error-color mt10">{{ $t('notice.upload_excel_tip', { value: $t('web.email') } /* 温馨提示:上传Excel数据必须包含邮箱列并将邮箱放在第一列 */) }}</p>
        <div class="mt10">
            <a-upload-dragger
                :action="uploadImageUrl"
                name="file_name"
                :data="{ type: 2 }"
                :before-upload="info => beforeUpload(info, 'file')"
                :headers="uploadHeaders"
                @change="handleFileChange"
                :showUploadList="false"
            >
                <a-icon style="font-size: 32px" class="theme-color" type="upload"></a-icon>
                <div class="mt10 fs16">{{ $t('notice.click_or_drag_upload' /* 点击或者拖拽上传文件 */) }}</div>
            </a-upload-dragger>
        </div>
        <a-spin tip="Loading..." :spinning="confirmLoading" style="width: 100%">
            <a-table v-if="dataSource.length" size="small" :rowKey="record => record.id" :dataSource="dataSource" :columns="columns" :pagination="false"></a-table>
            <a-form :form="form" v-if="dataSource.length">
                <a-form-item :label="$t('email_insert_tag' /* 点击插入标签 */)" class="mt15">
                    <a-space>
                        <a-button @click="handleSelectTagEvent(item)" v-for="(item, key, index) in label_list" :key="index" type="primary" ghost>{{ key }}</a-button>
                    </a-space>
                </a-form-item>
                <a-form-item :label="$t('email_sender_name' /* 发送人 */)">
                    <a-input v-decorator="['send_name', { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('email_sender_name' /* 发送人 */) }] }]" />
                </a-form-item>
                <a-form-item :label="$t('email_reply_email' /* 接受回信Email */)">
                    <a-input
                        v-decorator="[
                            'receive_email',
                            {
                                rules: [
                                    { required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('email_reply_email' /* 接受回信Email */) },
                                    { pattern: new RegExp(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/), message: $t('notice.email_format_error' /* 邮箱格式不正确 */) }
                                ]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item :label="$t('email_subject' /* 主题 */)">
                    <a-input v-decorator="['theme', { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('email_subject' /* 主题 */) }] }]" />
                </a-form-item>
                <a-form-item :label="$t('please_enter_email_content' /* 请输入短信内容 */)">
                    <tinymce-editor
                        ref="tinymceEditor"
                        v-decorator="['content', { rules: [{ required: true, message: $t('notice.please_enter_email_content' /* 请输入邮件内容 */) }] }]"
                    ></tinymce-editor>
                </a-form-item>
                <a-form-item class="t-c">
                    <a-button type="primary" style="width: 150px" size="large" @click="handelSubmit">{{ $t('notice.submit_button_text' /* 立即提交 */) }}</a-button>
                </a-form-item>
            </a-form>
        </a-spin>
    </div>
</template>
<script>
import userApi from '@/request/apiList';
import tinymceEditor from '@/components/Tinymce/index.vue';
export default {
    name: 'NoticeEmailTagConfig',
    components: { tinymceEditor },
    props: {},
    data() {
        return {
            form: this.$form.createForm(this),
            cursorPos: 0, //光标位置
            // 文件请求地址
            uploadImageUrl: userApi.sendUploadFile,
            // 请求头
            uploadHeaders: {},
            confirmLoading: false,
            // 文件上传受控列表
            fileList: [],
            fileStream: {},
            balance: {},
            dataSource: [], //成功列表 最多10条
            columns: [],
            label_list: [] //标签
        };
    },
    methods: {
        handelSubmit() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    const formData = new FormData();
                    formData.append('file_name', this.fileStream);
                    formData.append('type', 2);
                    for (let key in values) {
                        formData.append(key, values[key]);
                    }
                    this.$confirm({
                        title: this.$t('web.tips' /* 温馨提示 */),
                        content: this.$t('notice.confirm_send_content' /* 确认发送吗？ */),
                        onOk: () => {
                            this.$request
                                .post({ url: 'sendCustomExecute', data: formData })
                                .then(res => {
                                    this.$message.success(this.$t('notice.send_success' /* 发送成功 */));
                                    this.dataSource = [];
                                    this.getSendBalance();
                                })
                                .catch(err => {
                                    this.confirmLoading = false;
                                });
                        }
                    });
                }
            });
        },
        // 选择标签
        handleSelectTagEvent(item) {
            this.$refs.tinymceEditor.editor.execCommand('mceInsertContent', false, item);
        },

        // 用户余额
        getSendBalance() {
            this.$request.get({ url: 'getSendBalance' }).then(res => {
                this.balance = res.data;
            });
        },
        // 上传前
        beforeUpload(file, type) {
            return new Promise((resolve, reject) => {
                this.fileStream = file;
                let regFile = true;
                // 其他文件的验证
                if (type == 'file') {
                    // 取后台上传的后缀配置
                    // let options = currItem.options || [];
                    let options = ['xlsx'];
                    // 获取当前上传的文件后缀
                    let suffix = file.name.split('.');
                    suffix = suffix[suffix.length - 1];
                    if (options.length && options.indexOf(suffix) == -1) {
                        regFile = false;
                        this.$message.error(this.$t('notice.please_upload_file', { type: options.join('|') } /* 请上传后缀为{type}的格式 */));
                        return resolve(regFile);
                    }
                }
                return resolve(regFile);
            });
        },

        // 上传文件修改
        handleFileChange(info) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            // 2. read from response and show file link
            fileList = fileList.map(file => {
                if (file.response) {
                    let { code, data, message } = file.response;
                    if (code == 200) {
                        // file.url = data.relative_path;
                        this.label_list = data.label;
                        let index = 0;
                        this.columns = [];
                        this.dataSource = [];
                        for (const key in data.label) {
                            this.columns.push({
                                title: key,
                                dataIndex: 'id' + index
                            });
                            index++;
                        }
                        data.success_list.forEach((item, index) => {
                            this.dataSource[index] = { id: index };
                            item.forEach((it, idx) => {
                                this.dataSource[index]['id' + idx] = it;
                            });
                        });
                    } else {
                        this.$message.error(message);
                        file.status = 'error';
                    }
                }
                return file;
            });
            this.fileList = fileList;
        }
    },
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
        this.getSendBalance();
    }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 768px) {
    .info-item {
        .fs22 {
            font-size: 14px;
        }
    }
}
</style>
